export type ModalWidths =
	| 'small'
	| 'medium'
	| 'large'
	| 'xlarge'
	| 'max'
	| 'fullscreen'
	| 'resizable';

export const getADSModalWidth = (
	modalSize: ModalWidths,
): 'small' | 'medium' | 'large' | 'x-large' | '100%' | 'fullscreen' | 'auto' => {
	switch (modalSize) {
		case 'xlarge':
			return 'x-large';
		case 'max':
			return '100%';
		case 'resizable':
			// 'resizable' has not yet been implemented in this extension point modal (UI Kit) path, but return auto for now.
			// We must accommodate for this in the types because the ModalWidths type in this file is used for the overarching ModalExtension type in the renderer props.
			// TLDR: The types in this file are for when viewportSize: 'resizable' AS WELL AS Modal({ size: 'resizable' })
			return 'auto';
		default:
			return modalSize;
	}
};
